module.exports = __webpack_public_path__ + "img/story050@2x.449bf665.webp";